import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useEffect, useState } from "react";

export const useCaptchaV3 = (action) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [captchaToken, setCaptchaToken] = useState(null);

  useEffect(() => {
    const runRecaptcha = async () => {
      if (!executeRecaptcha) return;

      try {
        const token = await executeRecaptcha(action);
        setCaptchaToken(token);
      } catch (err) {
        console.error("Error executing reCAPTCHA:", err);
      }
    };

    runRecaptcha();
  }, [executeRecaptcha, action]);

  return { captchaToken };
};
